import styles from './loading.module.scss';
const PLAN_CARDS = 4;
const PLAN_FEATURES = 4;
const FAQ_ITEMS = 3;
export default function SubscriptionsLoading() {
  return <div className={styles.page} role="status" aria-live="polite" aria-label="Loading membership plans" data-sentry-component="SubscriptionsLoading" data-sentry-source-file="loading.tsx">
            <div className={styles.container}>
                {/* Header — eyebrow, title, subtitle */}
                <header className={styles.header} aria-hidden="true">
                    <span className={`${styles.shimmer} ${styles.eyebrow}`} />
                    <span className={`${styles.shimmer} ${styles.title}`} />
                    <span className={`${styles.shimmer} ${styles.subtitle}`} />
                </header>

                {/* 4-card pricing row — mirrors PlanCard layout */}
                <div className={styles.cardsRow} aria-hidden="true">
                    {Array.from({
          length: PLAN_CARDS
        }).map((_, i) => <div key={i} className={styles.card}>
                            <span className={`${styles.shimmer} ${styles.cardName}`} />
                            <span className={`${styles.shimmer} ${styles.cardDesc}`} />
                            <span className={`${styles.shimmer} ${styles.cardPrice}`} />
                            <ul className={styles.features}>
                                {Array.from({
              length: PLAN_FEATURES
            }).map((_, j) => <li key={j} className={styles.feature}>
                                        <span className={`${styles.shimmer} ${styles.featureCheck}`} />
                                        <span className={`${styles.shimmer} ${styles.featureLine}`} />
                                    </li>)}
                            </ul>
                            <span className={`${styles.shimmer} ${styles.cardCta}`} />
                            <span className={`${styles.shimmer} ${styles.cardLinkBtn}`} />
                        </div>)}
                </div>

                {/* FAQ — eyebrow, title, accordion items */}
                <div className={styles.faqWrap} aria-hidden="true">
                    <span className={`${styles.shimmer} ${styles.eyebrow}`} />
                    <span className={`${styles.shimmer} ${styles.faqTitle}`} />
                    <div className={styles.faqList}>
                        {Array.from({
            length: FAQ_ITEMS
          }).map((_, i) => <div key={i} className={styles.faqItem}>
                                <span className={`${styles.shimmer} ${styles.faqQuestion}`} />
                                <span className={`${styles.shimmer} ${styles.faqChevron}`} />
                            </div>)}
                    </div>
                </div>
            </div>
        </div>;
}